var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgR4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 35,
    viewBox: "0 0 57 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8833 35H29.543L46.66 17.5L29.543 0H39.8833L57.0004 17.5L39.8833 35Z",
    fill: "url(#paint0_linear_164_13841)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1128 35H14.7725L31.8876 17.5L14.7725 0H25.1128L42.228 17.5L25.1128 35Z",
    fill: "#FFED00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3404 35H0L17.1171 17.5L0 0H10.3404L27.4555 17.5L10.3404 35Z",
    fill: "#FFED00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_164_13841",
    x1: -30.3724,
    y1: 17.5,
    x2: -364.252,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D224"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR4);
export default __webpack_public_path__ + "static/media/r4.5e3f94bbf56b4c377a956a6bd8f63105.svg";
export { ForwardRef as ReactComponent };